export default [
  {
    path: '/track',
    name: 'Tracks',
    component: () => import(/* webpackChunkName: 'track' */ './views/Index.vue')
  }
]
